import React from 'react';
import { useTranslation } from 'react-i18next';
import {Trans} from 'react-i18next';
import Icon from '../../../../../../components/icon';
import {API_ROOT} from '../../../../../../utils';

const ExpiredEvalPopupMessage = (props) => {
	const { t } = useTranslation();

	return (
		<div className="p-4">
<h2 className="pr-5"><Icon name="lock" color="#c00" className="mr-2"/> <span className="text-danger">{t("textExpiredContent")}</span></h2>
			<p>	<Trans i18nKey="textExpiredContent2"/></p>
			<div className="text-right">
				<a onClick={props.getBack} role="button" className="btn btn-default text-white" href={`${API_ROOT}/api/payment/new`} target="_blank" rel="noreferrer">{t("textBuy")}</a>
			</div>
		</div>
	)
};

export default ExpiredEvalPopupMessage;